<template>
    <div class="row">
        <div class="col-md">
            <label>
                <span class="label">{{ label }}</span>
                <input type="password" class="form-control" v-model="password" @input="handleInput">
            </label>

            <ul class="checklist pt-2">
                <li :class="{checked: rule_length}">mindestens 8 Zeichen</li>
                <li :class="{checked: rule_chars}">Buchstaben, Zahlen und Sonderzeichen verwendet</li>
            </ul>
        </div>

        <div class="col-md mt-3 mt-md-0">
            <label>
                <span class="label">{{ label }} (Wiederholung)</span>
                <input type="password" class="form-control" v-model="repeat" @input="handleInput">
            </label>

            <ul class="checklist pt-2">
                <li :class="{checked: rule_repeat}">korrekt wiederholt</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {default: ''},
            label: {default: 'Passwort'},
        },

        data() {
            return {
                rule_length: false,
                rule_chars: false,
                rule_repeat: false,
                password: this.value,
                repeat: this.value,
            };
        },

        methods: {
            handleInput() {
                this.rule_length = this.password.length >= 8;
                this.rule_chars = /[\w]/.test(this.password) && /[\d]/.test(this.password) && /[\W]/.test(this.password);
                this.rule_repeat = this.password !== "" && this.password === this.repeat;
                this.$emit('input', (this.rule_length && this.rule_chars && this.rule_repeat) ? this.password : '');
            },
        },

        watch: {
            value() {
                if (this.value !== this.password) {
                    this.password = this.value;
                    this.repeat = this.value;
                }
            },
        },

        mounted() {
            this.handleInput();
        },
    };
</script>